import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Logo from '@arcblock/ux/lib/Logo';
import Typography from '@material-ui/core/Typography';

export default function DocLogo(props) {
  return (
    <Div {...props}>
      <Logo className="logo-icon" showText={false} />
      <div className="logo-typography">
        <Logo className="logo-text" showLogo={false} />
        <Typography className="logo-name" component="h2">
          {props.title}
        </Typography>
        <Typography component="span" className="doc-version">
          {props.version}
        </Typography>
      </div>
    </Div>
  );
}

DocLogo.propTypes = {
  version: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const Div = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  position: relative;

  .doc-version {
    position: absolute;
    top: 4px;
    right: -72px;
    background: ${props => props.theme.palette.text.primary};
    color: ${props => props.theme.palette.text.contrast};
    padding: 2px 6px;
    border-radius: 6px;
    font-size: 12px;
    font-family: source-code-pro, Menlo, Monaco, Consolas, Courier New, monospace;
    @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
      display: none;
    }
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    .logo-icon {
      transform: scale(0.8);
    }
  }

  .logo-typography {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    transform: scale(0.8);
  }

  .logo-name {
    margin-top: 4px;
    font-size: 24px;
    font-weight: 400;
  }
`;
